import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnifyRedirectComponent } from './unify-redirect/unify-redirect.component';



@NgModule({
  declarations: [UnifyRedirectComponent],
  imports: [
    CommonModule
  ],
  exports: [UnifyRedirectComponent]
})
export class UnifyRedirectModule { }
